import { useState } from "react"

export function useAiTextDescription() {
  const [descriptionValue, setDescriptionValue] = useState("")
  const [isShowAiModal, setIsShowAiModal] = useState(false)
  const [profileDescription, setProfileDescription] = useState("")

  return {
    descriptionValue,
    setDescriptionValue,
    isShowAiModal,
    setIsShowAiModal,
    profileDescription,
    setProfileDescription
  }
}